import "./leaderboard-item.less";
import {scrollIntoViewCenter} from "utils/helpers";
import {useEffect, useRef } from "react";

interface Props {
  place: number
  pointsText: string
  name: string
  isSelected: boolean
  className?: string
  isCorrect: boolean
}

export default function LeaderboardItem(props: Props) {
  const ref = useRef<HTMLDivElement>(null);
  let className = "leaderboard-item";
  if (props.className) {
    className += " " + props.className;
  }
  if (props.isSelected) {
    className += " selected";
  }
  if (props.isCorrect) { 
    className += " correct";
  } else {
    className += " incorrect";
  }

  useEffect(() => {
    const el = ref.current
    if (props.isSelected && el) {
        scrollIntoViewCenter(el)        
    }
  }, [props.isSelected, ref.current])
  
  return <div className={className} ref={ref}>
    <div className="place">{props.place}</div>
    <div className="name">{props.name}</div>
    <div className="points">{props.pointsText}</div>
  </div>
}